/* @luxottica/bipa-manager v3.3.3 */
function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

import { submitBipaFormRequest, loginRequest, bipaAgreementRequest } from '@luxottica/vto-microservices';
import React, { useState, useRef, useEffect } from 'react';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

___$insertStyle("#bipa-overlay-root-style.bipa-overlay {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: center;\n  font-size: 0.85rem;\n}\n#bipa-overlay-root-style.bipa-overlay * {\n  box-sizing: border-box;\n}\n#bipa-overlay-root-style.bipa-overlay *:focus {\n  outline: dodgerblue solid 1px;\n}\n#bipa-overlay-root-style.bipa-overlay h1 {\n  font-size: 1.4rem;\n  margin: 0;\n}\n#bipa-overlay-root-style.bipa-overlay span {\n  margin: 0;\n}\n#bipa-overlay-root-style.bipa-overlay .note-text {\n  font-size: 0.6rem;\n  color: #AAAAAA;\n}\n#bipa-overlay-root-style.bipa-overlay .note-warning {\n  color: #C83430;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container {\n  position: relative;\n  font-family: sans-serif;\n  height: 100%;\n  width: 100%;\n  max-width: 80vw;\n  display: flex;\n  margin: 0;\n  background-color: white;\n  color: black;\n  overflow: auto;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container .long-text {\n  overflow: auto;\n  min-height: 10%;\n  text-align: left;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container .line {\n  width: 100%;\n  margin: 0 0 1rem 0;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container .buttons {\n  display: flex;\n  justify-content: center;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container button {\n  padding: 0.2rem;\n  height: 2.6rem;\n  color: #000000;\n  background-color: #FFFFFF;\n  border: 1px solid #000000;\n  border-radius: 1.3rem;\n  margin: 0 0.6rem 0 0 !important;\n  flex-grow: 1;\n  cursor: pointer;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container button:hover {\n  background-color: #EEEEEE;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container button.confirm {\n  color: #FFFFFF;\n  background-color: #000000;\n  border: 1px solid #000000;\n  margin: 0 0 0 0.6rem !important;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container button.confirm:hover {\n  background-color: #222222;\n  border: 1px solid #222222;\n}\n#bipa-overlay-root-style.bipa-overlay #bipa-component-container button:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: default;\n}\n@media (min-width: 768px) {\n  #bipa-overlay-root-style.bipa-overlay #bipa-component-container {\n    max-width: 60vw;\n  }\n  #bipa-overlay-root-style.bipa-overlay #bipa-component-container button {\n    max-width: 10rem;\n  }\n}");

var BipaError = /*#__PURE__*/function (_Error) {
  _inherits(BipaError, _Error);

  var _super = _createSuper(BipaError);

  function BipaError(type, message, error) {
    var _this;

    _classCallCheck(this, BipaError);

    _this = _super.call(this, message);
    _this.type = type;
    _this.name = type;
    _this.message = message;
    _this.stack = error === null || error === void 0 ? void 0 : error.stack;
    Object.setPrototypeOf(_assertThisInitialized(_this), BipaError.prototype);
    return _this;
  }

  return BipaError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var MissingTranslationError = /*#__PURE__*/function (_BipaError) {
  _inherits(MissingTranslationError, _BipaError);

  var _super2 = _createSuper(MissingTranslationError);

  function MissingTranslationError(locale) {
    var _this2;

    _classCallCheck(this, MissingTranslationError);

    _this2 = _super2.call(this, MissingTranslationError.type, "translation missing for locale: ".concat(locale));
    Object.setPrototypeOf(_assertThisInitialized(_this2), MissingTranslationError.prototype);
    return _this2;
  }

  return MissingTranslationError;
}(BipaError);

MissingTranslationError.type = 'MissingTranslationError';

var BipaServiceError = /*#__PURE__*/function (_BipaError3) {
  _inherits(BipaServiceError, _BipaError3);

  var _super4 = _createSuper(BipaServiceError);

  function BipaServiceError(message, error) {
    var _this4;

    _classCallCheck(this, BipaServiceError);

    _this4 = _super4.call(this, BipaServiceError.type, message, error);
    Object.setPrototypeOf(_assertThisInitialized(_this4), BipaServiceError.prototype);
    return _this4;
  }

  return BipaServiceError;
}(BipaError);

BipaServiceError.type = 'BipaServiceError';

var BipaSubmissionError = /*#__PURE__*/function (_BipaError4) {
  _inherits(BipaSubmissionError, _BipaError4);

  var _super5 = _createSuper(BipaSubmissionError);

  function BipaSubmissionError(message, fieldErrors, error) {
    var _this5;

    _classCallCheck(this, BipaSubmissionError);

    _this5 = _super5.call(this, BipaSubmissionError.type, message, error);
    _this5.fieldErrors = fieldErrors;
    Object.setPrototypeOf(_assertThisInitialized(_this5), BipaSubmissionError.prototype);
    return _this5;
  }

  return BipaSubmissionError;
}(BipaError);

BipaSubmissionError.type = 'BipaSubmissionError';

var DefaultPrivacyLocalization = {
  PRIVACY_AGREEMENT_TITLE: 'Biometric data consent',
  PRIVACY_FIRST_AGREEMENT: 'We need your consent to record your face\'s biometric data and proceed with our eyewear suggestion experience. We will not store any of your information in our database and once the process is finished, we will delete all of your personal data.',
  PRIVACY_IMPLICIT_AGREEMENT: 'By continuing you accept',
  PRIVACY_IMPLICIT_TERMS_AND_CONDITIONS: 'Terms and Conditions',
  PRIVACY_IMPLICIT_TERMS_PRIVACY_CONJUNCTION: ' and ',
  PRIVACY_IMPLICIT_PRIVACY_POLICY: 'Privacy Policy',
  PRIVACY_BUTTON_SUBMIT: 'Submit',
  PRIVACY_BUTTON_CANCEL: 'Cancel',
  BIPA_FORM_TITLE: 'Biometric data consent',
  BIPA_CITIZEN_DECLARATION: 'I declare I\'m an Illinois citizen',
  BIPA_FORM_SUBTITLE: 'Due to some Illinois regulations we need to ask you some information, please fill in your details below.',
  BIPA_FORM_NAME: 'Name',
  BIPA_FORM_SURNAME: 'Surname',
  BIPA_FORM_EMAIL: 'E-mail',
  BIPA_IMPLICIT_AGREEMENT: 'By continuing you accept',
  BIPA_IMPLICIT_TERMS_AND_CONDITIONS: 'Terms and Conditions',
  BIPA_IMPLICIT_TERMS_PRIVACY_CONJUNCTION: ' and ',
  BIPA_IMPLICIT_PRIVACY_POLICY: 'Privacy Policy',
  BIPA_FORM_IMPLICIT_AGREEMENT: 'By continuing you accept Luxottica\'s Terms and Conditions and below BIPA Notice.',
  BIPA_FORM_BUTTON_SUBMIT: 'Submit',
  BIPA_FORM_BUTTON_CANCEL: 'Cancel',
  BIPA_SERVER_ERROR: 'There was a problem with the server, please check insered informations or network connection'
};

var currentLocalizationText;
var LocalizationHelper = {
  setText: function setText(localizationText) {
    currentLocalizationText = _objectSpread2(_objectSpread2(_objectSpread2({}, currentLocalizationText), DefaultPrivacyLocalization), localizationText);
  },
  getText: function getText(key) {
    return !!currentLocalizationText[key] ? currentLocalizationText[key] : '';
  }
};

var NOT_BLANK = 'NotBlank';
var SIZE = 'Size';
var PATTERN = 'Pattern';
var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var createFieldError = function createFieldError(field, message) {
  return {
    objectName: 'bipaConsentPublic',
    field: field,
    message: message
  };
};

var ParameterHelper = {
  validateBipaForm: function validateBipaForm(bipaForm) {
    var fieldErrors = [];

    if (!(bipaForm !== null && bipaForm !== void 0 && bipaForm.firstName)) {
      fieldErrors.push(createFieldError('firstName', NOT_BLANK));
    } else if (!!(bipaForm !== null && bipaForm !== void 0 && bipaForm.firstName) && bipaForm.firstName.trim().length < 2) {
      fieldErrors.push(createFieldError('firstName', SIZE));
    }

    if (!(bipaForm !== null && bipaForm !== void 0 && bipaForm.lastName)) {
      fieldErrors.push(createFieldError('lastName', NOT_BLANK));
    } else if (!!(bipaForm !== null && bipaForm !== void 0 && bipaForm.lastName) && bipaForm.lastName.trim().length < 2) {
      fieldErrors.push(createFieldError('lastName', SIZE));
    }

    if (!(bipaForm !== null && bipaForm !== void 0 && bipaForm.email)) {
      fieldErrors.push(createFieldError('email', NOT_BLANK));
    } else if (!!(bipaForm !== null && bipaForm !== void 0 && bipaForm.email) && bipaForm.email.trim().length < 2) {
      fieldErrors.push(createFieldError('email', SIZE));
    } else if (!!(bipaForm !== null && bipaForm !== void 0 && bipaForm.email) && !bipaForm.email.trim().match(EMAIL_REGEX)) {
      fieldErrors.push(createFieldError('email', PATTERN));
    }

    return fieldErrors;
  }
};

var PrivacyLocalizationKey;

(function (PrivacyLocalizationKey) {
  PrivacyLocalizationKey["PRIVACY_AGREEMENT_TITLE"] = "PRIVACY_AGREEMENT_TITLE";
  PrivacyLocalizationKey["PRIVACY_AGREEMENT_TEXT"] = "PRIVACY_AGREEMENT_TEXT";
  PrivacyLocalizationKey["PRIVACY_FIRST_AGREEMENT"] = "PRIVACY_FIRST_AGREEMENT";
  PrivacyLocalizationKey["PRIVACY_IMPLICIT_AGREEMENT"] = "PRIVACY_IMPLICIT_AGREEMENT";
  PrivacyLocalizationKey["PRIVACY_IMPLICIT_TERMS_AND_CONDITIONS"] = "PRIVACY_IMPLICIT_TERMS_AND_CONDITIONS";
  PrivacyLocalizationKey["PRIVACY_IMPLICIT_TERMS_PRIVACY_CONJUNCTION"] = "PRIVACY_IMPLICIT_TERMS_PRIVACY_CONJUNCTION";
  PrivacyLocalizationKey["PRIVACY_IMPLICIT_PRIVACY_POLICY"] = "PRIVACY_IMPLICIT_PRIVACY_POLICY";
  PrivacyLocalizationKey["PRIVACY_BUTTON_SUBMIT"] = "PRIVACY_BUTTON_SUBMIT";
  PrivacyLocalizationKey["PRIVACY_BUTTON_CANCEL"] = "PRIVACY_BUTTON_CANCEL";
  PrivacyLocalizationKey["BIPA_CITIZEN_DECLARATION"] = "BIPA_CITIZEN_DECLARATION";
  PrivacyLocalizationKey["BIPA_CITIZEN_QUESTION"] = "BIPA_CITIZEN_QUESTION";
  PrivacyLocalizationKey["BIPA_FORM_TITLE"] = "BIPA_FORM_TITLE";
  PrivacyLocalizationKey["BIPA_FORM_SUBTITLE"] = "BIPA_FORM_SUBTITLE";
  PrivacyLocalizationKey["BIPA_FORM_NAME"] = "BIPA_FORM_NAME";
  PrivacyLocalizationKey["BIPA_FORM_SURNAME"] = "BIPA_FORM_SURNAME";
  PrivacyLocalizationKey["BIPA_FORM_EMAIL"] = "BIPA_FORM_EMAIL";
  PrivacyLocalizationKey["BIPA_FORM_ERROR"] = "BIPA_FORM_ERROR";
  PrivacyLocalizationKey["BIPA_FORM_ERROR_MAIL"] = "BIPA_FORM_ERROR_MAIL";
  PrivacyLocalizationKey["BIPA_FORM_MANDATORY_FIELD"] = "BIPA_FORM_MANDATORY_FIELD";
  PrivacyLocalizationKey["BIPA_IMPLICIT_AGREEMENT"] = "BIPA_IMPLICIT_AGREEMENT";
  PrivacyLocalizationKey["BIPA_IMPLICIT_TERMS_AND_CONDITIONS"] = "BIPA_IMPLICIT_TERMS_AND_CONDITIONS";
  PrivacyLocalizationKey["BIPA_IMPLICIT_TERMS_PRIVACY_CONJUNCTION"] = "BIPA_IMPLICIT_TERMS_PRIVACY_CONJUNCTION";
  PrivacyLocalizationKey["BIPA_IMPLICIT_PRIVACY_POLICY"] = "BIPA_IMPLICIT_PRIVACY_POLICY";
  PrivacyLocalizationKey["BIPA_FORM_IMPLICIT_AGREEMENT"] = "BIPA_FORM_IMPLICIT_AGREEMENT";
  PrivacyLocalizationKey["BIPA_FORM_BIPA_AGREEMENT"] = "BIPA_FORM_BIPA_AGREEMENT";
  PrivacyLocalizationKey["BIPA_FORM_BUTTON_SUBMIT"] = "BIPA_FORM_BUTTON_SUBMIT";
  PrivacyLocalizationKey["BIPA_FORM_BUTTON_CANCEL"] = "BIPA_FORM_BUTTON_CANCEL";
  PrivacyLocalizationKey["BIPA_NO"] = "BIPA_NO";
  PrivacyLocalizationKey["BIPA_SERVER_ERROR"] = "BIPA_SERVER_ERROR";
  PrivacyLocalizationKey["BIPA_YES"] = "BIPA_YES";
})(PrivacyLocalizationKey || (PrivacyLocalizationKey = {}));

___$insertStyle("#bipa-overlay-root-style #bipa-biometric-agreement {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement #BIOMETRIC_AGREEMENT_TITLE {\n  text-align: center;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .field {\n  width: 100%;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .field.line {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .field label {\n  text-align: left;\n  margin: auto;\n  position: relative;\n  float: left;\n  padding: 0.5rem;\n  margin-bottom: calc(-50%);\n  color: #555;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .field input {\n  padding: 0.3rem;\n  margin: 0 2px;\n  width: 100%;\n  font-size: 1rem;\n  border: 2px solid #DDDDDD;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .field input.error {\n  border: 2px solid #C83430;\n  color: #C83430;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .field input:value ~ label {\n  background-color: lightblue;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .field .active label {\n  display: none;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .field .error-icon {\n  margin-left: -26px;\n}\n#bipa-overlay-root-style #bipa-biometric-agreement .error-text {\n  color: #C83430;\n  font-size: 0.7rem;\n  margin-top: -0.7rem;\n}");

var ErrorIcon = function ErrorIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: 'error-icon',
    width: '16',
    height: '17',
    viewBox: '0 0 16 17',
    fill: 'none'
  }, /*#__PURE__*/React.createElement("circle", {
    cx: '8',
    cy: '8.5',
    r: '7',
    stroke: '#C83430',
    strokeWidth: '2'
  }), /*#__PURE__*/React.createElement("path", {
    fill: '#C83430',
    d: 'M7 4.5h2v5H7z'
  }), /*#__PURE__*/React.createElement("rect", {
    x: '7',
    y: '10.5',
    width: '2',
    height: '2',
    rx: '1',
    fill: '#C83430'
  }));
};

var BipaBiometricForm = function BipaBiometricForm(props) {
  var _props$formPrefill, _props$formPrefill2, _props$formPrefill3;

  var _useState = useState(!!((_props$formPrefill = props.formPrefill) !== null && _props$formPrefill !== void 0 && _props$formPrefill.firstName) ? props.formPrefill.firstName : ''),
      _useState2 = _slicedToArray(_useState, 2),
      firstName = _useState2[0],
      setFirstName = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      firstNameError = _useState4[0],
      setFirstNameError = _useState4[1];

  var _useState5 = useState(!!((_props$formPrefill2 = props.formPrefill) !== null && _props$formPrefill2 !== void 0 && _props$formPrefill2.lastName) ? props.formPrefill.lastName : ''),
      _useState6 = _slicedToArray(_useState5, 2),
      lastName = _useState6[0],
      setLastName = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      lastNameError = _useState8[0],
      setLastNameError = _useState8[1];

  var _useState9 = useState(!!((_props$formPrefill3 = props.formPrefill) !== null && _props$formPrefill3 !== void 0 && _props$formPrefill3.email) ? props.formPrefill.email : ''),
      _useState10 = _slicedToArray(_useState9, 2),
      email = _useState10[0],
      setEmail = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      emailError = _useState12[0],
      setEmailError = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      serverError = _useState14[0],
      setServerError = _useState14[1];

  var topInputRef = useRef(undefined);
  useEffect(function () {
    var _props$callbacks, _props$callbacks$onDi;

    (_props$callbacks = props.callbacks) === null || _props$callbacks === void 0 ? void 0 : (_props$callbacks$onDi = _props$callbacks.onDisplayPage) === null || _props$callbacks$onDi === void 0 ? void 0 : _props$callbacks$onDi.call(_props$callbacks, 'BIOMETRIC_FORM');
  }, []);

  var onSubmitForm = function onSubmitForm() {
    var formData = {
      firstName: firstName,
      lastName: lastName,
      email: email
    };

    if (!serverError) {
      setServerError(false);
    }

    var fieldErrors = ParameterHelper.validateBipaForm(formData).map(function (error) {
      return error.field;
    });

    if (!firstName) {
      setFirstNameError(true);
    }

    if (!lastName) {
      setLastNameError(true);
    }

    if (!email) {
      setEmailError(true);
    }

    if (!firstName || !lastName || !email) {
      topInputRef.current.scrollIntoView();
    } else if (fieldErrors.length > 0) {
      if (fieldErrors.includes('firstName')) {
        setFirstNameError(true);
      }

      if (fieldErrors.includes('lastName')) {
        setLastNameError(true);
      }

      if (fieldErrors.includes('email')) {
        setEmailError(true);
      }

      topInputRef.current.scrollIntoView();
    } else {
      submitBipaFormRequest({
        source: props.source,
        environment: props.environment,
        accessToken: props.accessToken,
        refreshToken: props.refreshToken,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        bipaVersion: props.bipaVersion,
        onAuthUpdated: props.callbacks.onAuthUpdated
      }).then(function (response) {
        if (response.ok) {
          props.onBipaSubmit(formData);
        } else if (response.status < 404) {
          response.json().then(function (json) {
            var errorFields = !!(json !== null && json !== void 0 && json.fieldErrors) ? json.fieldErrors.map(function (error) {
              return error.field;
            }) : [];
            console.info(errorFields);

            if (errorFields.includes('firstName')) {
              setFirstNameError(true);
            }

            if (errorFields.includes('lastName')) {
              setLastNameError(true);
            }

            if (errorFields.includes('email')) {
              setEmailError(true);
            }
          });
        } else {
          setServerError(true);
          props.onError(new BipaServiceError("failed to submit bipa form due to response=".concat(response.status, " ").concat(response.statusText)));
        }
      })["catch"](function (e) {
        setServerError(true);
        props.onError(e);
      });
    }
  };

  var handleInputChange = function handleInputChange(element, dispatch) {
    if (!!element.target.value && element.target.value !== '') {
      dispatch(element.target.value);
    } else {
      dispatch('');
    }
  };

  var confirmButtonDisabled = firstName === undefined || firstName === '' || lastName === undefined || lastName === '' || email === undefined || email === '';
  var showFieldWarning = firstNameError || lastNameError || emailError;
  return /*#__PURE__*/React.createElement("div", {
    id: 'bipa-biometric-agreement'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'top'
  }, /*#__PURE__*/React.createElement("h1", {
    id: 'BIOMETRIC_AGREEMENT_TITLE',
    className: 'line'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_TITLE)), /*#__PURE__*/React.createElement("p", {
    id: 'BIPA_FORM_SUBTITLE',
    className: 'line'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_SUBTITLE)), showFieldWarning && /*#__PURE__*/React.createElement("p", {
    id: 'bipa-field-warning',
    className: 'note-warning'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_ERROR)), serverError && /*#__PURE__*/React.createElement("p", {
    id: 'bipa-server-warning',
    className: 'note-warning'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_SERVER_ERROR)), /*#__PURE__*/React.createElement("div", {
    className: 'field line'
  }, /*#__PURE__*/React.createElement("input", {
    ref: topInputRef,
    name: 'BIPA_FORM_NAME',
    id: 'bipa-data-collection-name',
    className: firstNameError ? 'error' : '',
    autoComplete: 'given-name',
    value: firstName,
    onChange: function onChange(element) {
      setFirstNameError(false);
      handleInputChange(element, setFirstName);
    },
    placeholder: LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_NAME)
  }), firstNameError && /*#__PURE__*/React.createElement(ErrorIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: 'field line'
  }, /*#__PURE__*/React.createElement("input", {
    name: 'BIPA_FORM_SURNAME',
    id: 'bipa-data-collection-surname',
    className: lastNameError ? 'error' : '',
    autoComplete: 'family-name',
    value: lastName,
    onChange: function onChange(element) {
      setLastNameError(false);
      handleInputChange(element, setLastName);
    },
    placeholder: LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_SURNAME)
  }), lastNameError && /*#__PURE__*/React.createElement(ErrorIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: 'field line'
  }, /*#__PURE__*/React.createElement("input", {
    name: 'BIPA_FORM_EMAIL',
    id: 'bipa-data-collection-email',
    className: emailError ? 'error' : '',
    autoComplete: 'email',
    value: email,
    onChange: function onChange(element) {
      setEmailError(false);
      handleInputChange(element, setEmail);
    },
    placeholder: LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_EMAIL)
  }), emailError && /*#__PURE__*/React.createElement(ErrorIcon, null)), emailError && /*#__PURE__*/React.createElement("div", {
    id: 'bipa-form-error-mail',
    className: 'error-text'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_ERROR_MAIL)), /*#__PURE__*/React.createElement("div", {
    id: 'bipa-mandatory-field',
    className: 'note-text'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_MANDATORY_FIELD))), /*#__PURE__*/React.createElement("div", {
    className: 'bottom'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'line buttons'
  }, /*#__PURE__*/React.createElement("button", {
    id: 'bipa-cancel-button',
    onClick: props.onCancel
  }, /*#__PURE__*/React.createElement("span", {
    id: 'BIPA_FORM_BUTTON_CANCEL'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_BUTTON_CANCEL))), /*#__PURE__*/React.createElement("button", {
    id: 'bipa-submit-button',
    onClick: onSubmitForm,
    className: 'confirm',
    disabled: confirmButtonDisabled
  }, /*#__PURE__*/React.createElement("span", {
    id: 'BIPA_FORM_BUTTON_SUBMIT'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_BUTTON_SUBMIT))))));
};

___$insertStyle("#bipa-overlay-root-style #privacy-agreement {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n#bipa-overlay-root-style #privacy-agreement .scrollable-container {\n  overflow-y: scroll;\n}\n#bipa-overlay-root-style #privacy-agreement .scrollable-container .scrollable-content #PRIVACY_AGREEMENT_TITLE {\n  text-align: center;\n}\n#bipa-overlay-root-style #privacy-agreement .scrollable-container .scrollable-content #BIPA_CITIZEN_QUESTION {\n  font-weight: bold;\n}\n#bipa-overlay-root-style #privacy-agreement .scrollable-container .scrollable-content #PRIVACY_AGREEMENT_TEXT p {\n  text-align: left !important;\n}\n#bipa-overlay-root-style #privacy-agreement .scrollable-container .scrollable-content #BIPA_FORM_BIPA_AGREEMENT p {\n  text-align: left !important;\n}\n#bipa-overlay-root-style #privacy-agreement .scrollable-container .scrollable-content .blank-footer {\n  width: 100%;\n  height: 100px;\n}\n#bipa-overlay-root-style #privacy-agreement .scrollable-container .scroll-gradient {\n  width: 100%;\n  height: 30%;\n  background: linear-gradient(0deg, white 0%, rgba(255, 255, 255, 0) 100%);\n  position: sticky;\n  bottom: 0;\n  pointer-events: none;\n}\n#bipa-overlay-root-style #privacy-agreement .scrollable-container .scroll-gradient.hidden {\n  display: none;\n}\n#bipa-overlay-root-style #privacy-agreement .footer-bar {\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: #FFFFFF;\n  align-items: center;\n  box-shadow: 0px 0px 10px #AAAAAA;\n  z-index: 1;\n}\n#bipa-overlay-root-style #privacy-agreement .footer-bar .footer-content {\n  width: 100%;\n  padding: 0 1rem;\n}\n@media (min-width: 768px) {\n  #bipa-overlay-root-style #privacy-agreement .footer-bar .footer-content {\n    max-width: 60vw;\n  }\n}\n#bipa-overlay-root-style #privacy-agreement .footer-bar .footer-content #PRIVACY_IMPLICIT_TERMS_AND_CONDITIONS {\n  font-weight: bold;\n  text-decoration: underline;\n  color: black;\n}\n#bipa-overlay-root-style #privacy-agreement .footer-bar .footer-content #bipa-privacy-policy-notice {\n  text-align: center;\n}");

___$insertStyle("#bipa-overlay-root-style .yes-no-checkbox {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n#bipa-overlay-root-style .yes-no-checkbox .no, #bipa-overlay-root-style .yes-no-checkbox .yes {\n  opacity: 0.5;\n}\n#bipa-overlay-root-style .yes-no-checkbox .no.selected, #bipa-overlay-root-style .yes-no-checkbox .yes.selected {\n  opacity: 1;\n  font-weight: bold;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch {\n  position: relative;\n  display: inline-block;\n  width: 2.4rem;\n  height: 1.4rem;\n  margin: 0 0.5rem;\n  /* Rounded sliders */\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch:focus-within {\n  outline: dodgerblue solid 1px;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #DDDDDD;\n  -webkit-transition: 0.2s;\n  transition: 0.2s;\n  border: 0rem solid #DDDDDD;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch .slider::before {\n  position: absolute;\n  content: \"\";\n  height: 1.12rem;\n  width: 1.12rem;\n  left: 0.14rem;\n  bottom: 0.14rem;\n  background-color: #FFFFFF;\n  -webkit-transition: 0.2s;\n  transition: 0.2s;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch input:checked + .slider {\n  background-color: #000000;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch input:focus + .slider {\n  box-shadow: 0 0 0rem black;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch input:checked + .slider::before {\n  -webkit-transform: translateX(1rem);\n  -ms-transform: translateX(1rem);\n  transform: translateX(1rem);\n  background-color: #FFFFFF;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch .slider.round {\n  border-radius: 0.7rem;\n}\n#bipa-overlay-root-style .yes-no-checkbox .switch .slider.round::before {\n  border-radius: 50%;\n}");

var YesNoCheckBox = function YesNoCheckBox(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: 'yes-no-checkbox'
  }, /*#__PURE__*/React.createElement("span", {
    className: "no".concat(props.checked ? '' : ' selected')
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_NO)), /*#__PURE__*/React.createElement("label", {
    className: 'switch'
  }, /*#__PURE__*/React.createElement("input", {
    type: 'checkbox',
    tabIndex: props.tabIndex,
    checked: props.checked,
    onChange: function onChange(event) {
      props.onChange(event.target.checked);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: 'slider round'
  })), /*#__PURE__*/React.createElement("span", {
    className: "yes".concat(props.checked ? ' selected' : '')
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_YES)));
};

var PrivacyAgreement = function PrivacyAgreement(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showGradient = _useState2[0],
      setShowGradient = _useState2[1];

  useEffect(function () {
    var _props$callbacks, _props$callbacks$onDi;

    (_props$callbacks = props.callbacks) === null || _props$callbacks === void 0 ? void 0 : (_props$callbacks$onDi = _props$callbacks.onDisplayPage) === null || _props$callbacks$onDi === void 0 ? void 0 : _props$callbacks$onDi.call(_props$callbacks, 'PRIVACY');

    try {
      if (document.getElementsByClassName('scrollable-container')[0].clientHeight >= document.getElementsByClassName('scrollable-content')[0].clientHeight) {
        setShowGradient(false);
      }
    } catch (e) {}
  }, []);

  var trackScrolling = function trackScrolling(e) {
    if (e.currentTarget.scrollTop < 2) {
      !showGradient && setShowGradient(true);
    } else {
      showGradient && setShowGradient(false);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    id: 'privacy-agreement'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'scrollable-container',
    onScroll: trackScrolling
  }, /*#__PURE__*/React.createElement("div", {
    className: 'scrollable-content'
  }, /*#__PURE__*/React.createElement("h1", {
    id: 'PRIVACY_AGREEMENT_TITLE'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.PRIVACY_AGREEMENT_TITLE)), /*#__PURE__*/React.createElement("div", {
    id: 'bipa-record-consent',
    className: 'line'
  }, /*#__PURE__*/React.createElement("p", {
    id: 'bipa-record-consent-text'
  }, /*#__PURE__*/React.createElement("span", {
    id: 'PRIVACY_FIRST_AGREEMENT',
    dangerouslySetInnerHTML: {
      __html: LocalizationHelper.getText(PrivacyLocalizationKey.PRIVACY_FIRST_AGREEMENT)
    }
  }))), props.region === 'US' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: 'bipa-citizen-question-container',
    className: 'line'
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: 'bipa-citizen-checkbox'
  }, /*#__PURE__*/React.createElement("span", {
    id: 'BIPA_CITIZEN_QUESTION'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_CITIZEN_QUESTION)))), /*#__PURE__*/React.createElement("div", {
    id: 'bipa-citizen-switch',
    className: 'line'
  }, /*#__PURE__*/React.createElement(YesNoCheckBox, {
    tabIndex: 0,
    checked: props.isIllinoisUser,
    onChange: function onChange(checked) {
      props.onSetIllinoisUser(checked);
    }
  }))), /*#__PURE__*/React.createElement("span", {
    id: 'PRIVACY_AGREEMENT_TEXT',
    dangerouslySetInnerHTML: {
      __html: "".concat(LocalizationHelper.getText(PrivacyLocalizationKey.PRIVACY_AGREEMENT_TEXT))
    }
  }), props.region === 'US' && /*#__PURE__*/React.createElement("span", {
    id: 'BIPA_FORM_BIPA_AGREEMENT',
    className: 'small',
    dangerouslySetInnerHTML: {
      __html: "".concat(LocalizationHelper.getText(PrivacyLocalizationKey.BIPA_FORM_BIPA_AGREEMENT))
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: 'blank-footer'
  })), /*#__PURE__*/React.createElement("div", {
    className: "scroll-gradient".concat(showGradient ? '' : ' hidden')
  })), /*#__PURE__*/React.createElement("div", {
    id: 'bipa-footer-bar',
    className: 'footer-bar'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'footer-content'
  }, /*#__PURE__*/React.createElement("p", {
    id: 'bipa-privacy-policy-notice'
  }, /*#__PURE__*/React.createElement("span", {
    id: 'PRIVACY_IMPLICIT_AGREEMENT',
    dangerouslySetInnerHTML: {
      __html: "".concat(LocalizationHelper.getText(PrivacyLocalizationKey.PRIVACY_IMPLICIT_AGREEMENT), "&nbsp;")
    }
  }), /*#__PURE__*/React.createElement("a", {
    target: '_blank',
    rel: 'noreferrer',
    href: props.privacyOptions.termsAndConditions.href,
    onClick: props.callbacks.onTermsAndConditionsClick && function (e) {
      e.preventDefault();
      props.callbacks.onTermsAndConditionsClick();
    }
  }, /*#__PURE__*/React.createElement("span", {
    id: 'PRIVACY_IMPLICIT_TERMS_AND_CONDITIONS'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.PRIVACY_IMPLICIT_TERMS_AND_CONDITIONS)))), /*#__PURE__*/React.createElement("div", {
    className: 'line buttons'
  }, /*#__PURE__*/React.createElement("button", {
    id: 'bipa-cancel-button',
    onClick: props.onCancel
  }, /*#__PURE__*/React.createElement("span", {
    id: 'PRIVACY_BUTTON_CANCEL'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.PRIVACY_BUTTON_CANCEL))), /*#__PURE__*/React.createElement("button", {
    id: 'bipa-submit-button',
    onClick: props.onSubmit,
    className: 'confirm'
  }, /*#__PURE__*/React.createElement("span", {
    id: 'PRIVACY_BUTTON_SUBMIT'
  }, LocalizationHelper.getText(PrivacyLocalizationKey.PRIVACY_BUTTON_SUBMIT)))))));
};

var ROOT_STYLE_NAME = 'bipa-overlay-root-style';

var BASIC_COOKIE_NAME = 'BasicImageConsent=true';
var BIOMETRIC_COOKIE_NAME = 'MlProcessImageConsent=true';
var COOKIE_PATH = 'path=/';
var CookieHelper = {
  setBiometricCookie: function setBiometricCookie(agreementType) {
    if (!CookieHelper.biometricCookieExists(agreementType)) {
      document.cookie = "".concat(CookieHelper.getBiometricCookieName(agreementType), ";").concat(COOKIE_PATH);
    }
  },
  biometricCookieExists: function biometricCookieExists(agreementType) {
    if (agreementType === "BASIC"
    /* BASIC */
    ) {
        return document.cookie.includes(CookieHelper.getBiometricCookieName("BASIC"
        /* BASIC */
        )) || document.cookie.includes(CookieHelper.getBiometricCookieName("BIOMETRIC"
        /* BIOMETRIC */
        ));
      } else if (agreementType === "BIOMETRIC"
    /* BIOMETRIC */
    ) {
        return document.cookie.includes(CookieHelper.getBiometricCookieName("BIOMETRIC"
        /* BIOMETRIC */
        ));
      } else {
      return false;
    }
  },
  getBiometricCookieName: function getBiometricCookieName(agreementType) {
    return agreementType === "BIOMETRIC"
    /* BIOMETRIC */
    ? BIOMETRIC_COOKIE_NAME : BASIC_COOKIE_NAME;
  }
};

var localizationBaseUrl = 'https://d5nhc6q3o19l2.cloudfront.net';

var fetchBipaJson = function fetchBipaJson(agreementType, environment, locale) {
  if (agreementType === "BASIC"
  /* BASIC */
  ) {
      // const localizationFileUrl = `${localizationBaseUrl}/frame-advisor/${locale}/bipa-vm_${locale}.json`;
      // TODO: update environment
      var localizationFileUrl = "".concat(localizationBaseUrl, "/vmmv/v1/prod/privacy/application_").concat(locale, ".json");
      return fetch(localizationFileUrl).then(function (response) {
        if (response.ok) {
          return response.json();
        } else {
          throw new MissingTranslationError(locale);
        }
      });
    } else {
    var _localizationFileUrl = "".concat(localizationBaseUrl, "/frame-advisor/v2/").concat(bipaJsonEnv(environment), "/privacy/privacy_").concat(locale, ".json");

    return fetch(_localizationFileUrl).then(function (response) {
      if (response.ok) {
        return response.json();
      } else {
        throw new MissingTranslationError(locale);
      }
    });
  }
};

var bipaJsonEnv = function bipaJsonEnv(environment) {
  switch (environment) {
    case 'STAGING':
      return 'dev';

    case 'PRODUCTION':
      return 'prod';

    case 'ACCEPTANCE':
    default:
      return 'test';
  }
};

var BipaOverlay = function BipaOverlay(props) {
  var isFirstRender = useRef(true);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      illinoisUser = _useState2[0],
      setIlliniosUser = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      bipaVersion = _useState6[0],
      setBipaVersion = _useState6[1];

  var onClickSubmit = function onClickSubmit() {
    if (illinoisUser) {
      setCurrentPage('BIOMETRIC_FORM');
    } else {
      CookieHelper.setBiometricCookie(props.type);
      props.callbacks.onSubmit();
    }
  };

  var onClickBipaSubmit = function onClickBipaSubmit(formData) {
    CookieHelper.setBiometricCookie(props.type);
    props.callbacks.onSubmit(formData);
  };

  var onClickCancel = function onClickCancel() {
    props.callbacks.onUserReject();
  };

  useEffect(function () {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      loginRequest({
        environment: props.environment,
        version: props.tokenVersion,
        accessToken: props.accessToken,
        refreshToken: props.refreshToken,
        onAuthUpdated: props.callbacks.onAuthUpdated
      }).then(function (loginReturn) {
        return Promise.all([fetchBipaJson(props.type, props.environment, props.locale), props.region === 'US' ? bipaAgreementRequest({
          locale: props.locale,
          environment: props.environment,
          accessToken: loginReturn.accessToken,
          refreshToken: loginReturn.refreshToken,
          onAuthUpdated: props.callbacks.onAuthUpdated
        }) : Promise.resolve(undefined)]);
      }).then(function (response) {
        var _response$, _response$2;

        var bipaAgreementText = !!(response !== null && response !== void 0 && (_response$ = response[1]) !== null && _response$ !== void 0 && _response$.text) ? response[1].text : undefined;
        var bipaAgreementVersion = !!(response !== null && response !== void 0 && (_response$2 = response[1]) !== null && _response$2 !== void 0 && _response$2.version) ? response[1].version : undefined;
        LocalizationHelper.setText(_objectSpread2(_objectSpread2({}, response[0]), {}, {
          BIPA_FORM_BIPA_AGREEMENT: bipaAgreementText
        }, props.privacy.localizationText));
        setBipaVersion(bipaAgreementVersion);
        setCurrentPage('PRIVACY');
      })["catch"](function (e) {
        props.callbacks.onError(e);
      });
    }
  }, []);

  var renderPage = function renderPage(props, currentPage) {
    if (currentPage === 'PRIVACY') {
      return /*#__PURE__*/React.createElement(PrivacyAgreement, {
        privacyOptions: props.privacy,
        callbacks: props.callbacks,
        region: props.region,
        isIllinoisUser: illinoisUser,
        onSetIllinoisUser: function onSetIllinoisUser(isIllinoisUser) {
          setIlliniosUser(isIllinoisUser);
        },
        onSubmit: onClickSubmit,
        onCancel: onClickCancel
      });
    } else if (currentPage === 'BIOMETRIC_FORM') {
      return /*#__PURE__*/React.createElement(BipaBiometricForm, {
        accessToken: props.accessToken,
        refreshToken: props.refreshToken,
        environment: props.environment,
        source: props.source,
        bipaVersion: bipaVersion,
        privacyOptions: props.privacy,
        callbacks: props.callbacks,
        formPrefill: props.formPrefill,
        onBipaSubmit: onClickBipaSubmit,
        onCancel: function onCancel() {
          return setCurrentPage('PRIVACY');
        },
        onError: props.callbacks.onError
      });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    id: ROOT_STYLE_NAME,
    className: 'bipa-overlay'
  }, /*#__PURE__*/React.createElement("div", {
    id: 'bipa-component-container'
  }, renderPage(props, currentPage)));
};

var BipaManager = {
  getCookieName: function getCookieName(agreementType) {
    return CookieHelper.getBiometricCookieName(agreementType);
  },
  biometricCookieExists: function biometricCookieExists(agreementType) {
    return CookieHelper.biometricCookieExists(agreementType);
  },
  getBipaVersion: function getBipaVersion(config) {
    return bipaAgreementRequest({
      locale: config.locale,
      environment: config.environment,
      accessToken: config.accessToken,
      refreshToken: config.refreshToken,
      onAuthUpdated: config.onAuthUpdated
    });
  },
  saveBipaEntry: function saveBipaEntry(config) {
    var fieldErrors = ParameterHelper.validateBipaForm(config.formData);

    if (fieldErrors.length > 0) {
      return Promise.reject(new BipaSubmissionError('failed client-side bipa form validation', fieldErrors));
    }

    return submitBipaFormRequest({
      environment: config.environment,
      accessToken: config.accessToken,
      refreshToken: config.refreshToken,
      onAuthUpdated: config.onAuthUpdated,
      bipaVersion: config.bipaVersion,
      source: config.source,
      firstName: config.formData.firstName,
      lastName: config.formData.lastName,
      email: config.formData.email
    }).then(function (response) {
      return response.json().then(function (json) {
        return {
          response: response,
          body: json
        };
      });
    }).then(function (responseData) {
      if (responseData.response.ok) {
        return responseData.response;
      } else {
        var _responseData$body, _responseData$body2;

        return !!((_responseData$body = responseData.body) !== null && _responseData$body !== void 0 && _responseData$body.title) && !!((_responseData$body2 = responseData.body) !== null && _responseData$body2 !== void 0 && _responseData$body2.message) ? Promise.reject(new BipaSubmissionError("".concat(responseData.body.title, ": ").concat(responseData.body.message), responseData.body.fieldErrors)) : Promise.reject(new BipaSubmissionError('failed to contact bipa server', undefined));
      }
    })["catch"](function (e) {
      if (e instanceof BipaSubmissionError) {
        throw e;
      } else {
        throw new BipaSubmissionError('failed to contact bipa server', undefined);
      }
    });
  }
};

export { BipaManager, BipaOverlay, PrivacyLocalizationKey };
//# sourceMappingURL=bipa-manager.js.map
